module.factory('referrerService', ['Session', function(Session) {

  var referrer = Session.getReferrer() || document.referrer;
  var referrerDomain = assignDomain();
  var sourceChannel = assignSourceChannel();
  var sourceCampaign = assignSourceCampaign();
  var sourceTags = assignSourceTags();

  var service = {
    get: get,
    getDomain: getDomain,
    getSourceChannel: getSourceChannel,
    getSourceCampaign: getSourceCampaign,
    getSourceTags: getSourceTags,
  };

  return service;

  function get() {
    return referrer;
  }

  function getDomain() {
    return referrerDomain;
  }

  function getSourceChannel(){
    return sourceChannel;
  }  

  function getSourceCampaign(){
    return sourceCampaign;
  } 

  function getSourceTags(){
    return sourceTags;
  } 

  function assignDomain() {
    if(referrer != 'direct'){
      var domain = getHost(referrer); // lets get the root domain now
      var sd = domain.split('.'); // split the domain

      // check if there is a subdomain
      if(sd.length > 3){
        domain = sd.slice(-3).join('.');
      }

      return domain;
    }
  }

  function assignSourceChannel() {
    if(branchData && branchData.data_parsed && branchData.data_parsed['~channel']) {
      return branchData.data_parsed['~channel'];
    } else {
      return '';
    }
  }

  function assignSourceCampaign() {
    if(branchData && branchData.data_parsed && branchData.data_parsed['~campaign']) {
      return branchData.data_parsed['~campaign'];
    } else {
      return '';
    }
  }

  function assignSourceTags() {
    if(branchData && branchData.data_parsed && branchData.data_parsed['~tags'] && branchData.data_parsed['~tags'] instanceof Array) {
      return JSON.stringify(branchData.data_parsed['~tags']).replace('[', '').replace(']', '').replace(/\"/g, '');
    } else {
      return '';
    }
  }

  function getHost(url){
    // parse host name from ak_ref cookie
    var parser = document.createElement('a');
    parser.href = url;

    return parser.host;
  }

}]);
